import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { seoWords } from './shared/seoWords'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { callToAction } from 'components/Wizards/schemas/shared/callToAction'
import { productDescription } from 'components/Wizards/schemas/shared/productDescription'
import { avoid } from 'components/Wizards/schemas/shared/avoid'
import { additionalInfo } from 'components/Wizards/schemas/shared/additionalInfo'
import { includeImages } from './shared/includeImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'

const meta = {
  type: GenerationType.Campaign,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183781/Home%20Card%20Previews/dqdiitgodirumvlbfs05.png',
}

const fields = {
  topic: topic.meta({ label: 'What is this campaign about?', generationType: meta.type }),
  filename: filename.transform(safify),
  project,
  language,
  reference_text: string()
    .default('')
    .meta({ label: "Add the source content you'd like us to create campaign content around" })
    .transform(safify),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  tone,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  seo_words: seoWords.meta({ label: 'What keywords should be included?' }),
  call_to_action: callToAction.meta({ collapsible: true }),
  author_persona: string()
    .default('')
    .meta({
      label: 'Author Persona',
      mobilePlaceholder: 'Who should the post be written as',
      placeholder: 'Who should the post be written as (e.g. Tech CEO)',
      snippets: true,
      autoFill: true,
      collapsible: true,
    })
    .transform(safify),
  product_description: productDescription.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
  additional_info: additionalInfo.meta({ collapsible: true }),
}

export const CampaignSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>
